
export default {
  month: 'mes | meses'
}
